import type { TransactionRecord, TransactionItem } from '@/types/Transaction'

export function createTransaction(data?: Partial<TransactionRecord>): TransactionRecord {
  return {
    transaction_number: data?.transaction_number ?? `TX-${Date.now()}`,
    transaction_type: data?.transaction_type ?? 'purchase',
    transaction_status: data?.transaction_status ?? 'pending',
    transaction_date: data?.transaction_date ?? new Date(),
    party_id: data?.party_id ?? '',
    party_data: data?.party_data ?? {
      id: '',
      name: '',
      company_name: null,
      email: null,
      phone: null,
      address: null,
      party_type: 'supplier',
    },
    total_amount: data?.total_amount ?? 0,
    payment_method: data?.payment_method ?? 'cash',
    payment_status: data?.payment_status ?? 'pending',
    processed_by_user_id: data?.processed_by_user_id ?? '',
    notes: data?.notes ?? null,
    created_at: data?.created_at ?? new Date(),
    updated_at: data?.updated_at ?? new Date(),
    is_deleted: data?.is_deleted ?? false,
    items: data?.items ?? [],
    vehicle_id: data?.vehicle_id ?? '',
    vehicleId: data?.vehicleId ?? '',
    party_signature: data?.party_signature ?? null,
  }
}

export function createTransactionItem(data?: Partial<TransactionItem>): TransactionItem {
  return {
    name: data?.name ?? '',
    quantity: data?.quantity ?? 0,
    unit_price: data?.unit_price ?? 0,
    price_per_lb: data?.price_per_lb ?? 0,
    total_price: data?.total_price ?? 0,
    weight: {
      gross: data?.weight?.gross ?? null,
      tare: data?.weight?.tare ?? null,
      net: data?.weight?.net ?? null,
    },
    commodity_type_id: data?.commodity_type_id ?? '',
    image_url: data?.image_url ?? null,
    image_preview: data?.image_preview,
    notes: data?.notes ?? null,
    commodity_name: data?.commodity_name,
  }
}
